import store from "../store"

export const newToast = (message, type = "info") => {
  store.dispatch("newAppNotification", { message, type })
}
